import React, { useState } from "react";
import { Tooltip } from "antd";
import Rating from "react-rating";
import { AnimatePresence } from "framer-motion";

// styles
import styles from "./styles.module.scss";

// assets
import starFilled from "src/assets/images/details/star_filled.svg";
import star from "src/assets/images/details/star.svg";
import rate from "src/assets/images/details/rate.svg";

// components
import ReviewModal from "./ReviewModal/ReviewModal";

const ReviewInfo = ({ data, setReFetch }) => {
  const [isShow, setIsShow] = useState(false);

  const toggle = (_refetch) => {
    setIsShow(!isShow);

    if (_refetch) {
      setReFetch(true);
    }
  };

  return (
    <>
      <div className={styles.head}>
        <h6>Reviews</h6>
        <h1>{parseFloat(data?.ratings || data?.Ratings).toFixed(1)}</h1>
        <div className={styles.stars}>
          <Rating
            initialRating={parseFloat(data?.ratings || data?.Ratings).toFixed(
              1
            )}
            emptySymbol={<img src={star} alt="stars" />}
            fullSymbol={<img src={starFilled} alt="stars filled" />}
            readonly
          />
          <span className={styles.count}>({data?.RatingCount || 0})</span>
        </div>
        <Tooltip
          placement="top"
          title="Add a rating and let others know about this awesome event"
        >
          <button className={styles.rate_event} onClick={() => toggle()}>
            <img src={rate} alt="rate-event" /> Rate Event
          </button>
        </Tooltip>
      </div>
      <div className={styles.head__mob}>
        <div>
          <h6>Reviews</h6>
          <h1>{parseFloat(data?.ratings || data?.Ratings).toFixed(1)}</h1>
          <div className={styles.stars}>
            <Rating
              initialRating={parseFloat(data?.ratings || data?.Ratings).toFixed(
                1
              )}
              emptySymbol={<img src={star} alt="stars" />}
              fullSymbol={<img src={starFilled} alt="stars filled" />}
              readonly
            />
            <span className={styles.count}>({data?.RatingCount})</span>
          </div>
        </div>
        <button className={styles.rate_event} onClick={() => toggle()}>
          <img src={rate} alt="rate-event" /> Rate Event
        </button>
      </div>
      <AnimatePresence>
        {isShow && <ReviewModal toggle={toggle} data={data} />}
      </AnimatePresence>
    </>
  );
};

export default ReviewInfo;
